module.exports = __webpack_public_path__ + "static/img/1111111.c43e52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1111111.png
// module id = BPvj
// module chunks = 1